import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import PaginaInicialDesktop from "./pages/PaginaInicialDesktop";
import PaginaInicialMobile from "./pages/PaginaInicialMobile";
import Agendamento from "./components/Agendamento";
import Relatorios from "./pages/Relatorios";
import "./App.css";

function App() {
  const location = useLocation();

  return (
    <div className="App">
      {location.pathname !== '/room/:roomId' && <Header />}
      <Routes>
        <Route path="/" element={<PaginaInicialDesktop />} />
        <Route path="/room/:roomId" element={<PaginaInicialMobile />} />
        <Route path="/agendamento" element={<Agendamento />} />
        <Route path="/relatorios" element={<Relatorios />}/>
      </Routes>
      <ToastContainer />
    </div>
  );
}

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
